export const initialLocations = [
  { id: 'loc1', name: 'Paphos Office', address: '12 Apostolou Pavlou, Paphos', fee: 0, isDefault: true, areaId: 'area-paphos' },
  { id: 'loc2', name: 'Paphos Airport', address: 'Paphos International Airport', fee: 25, areaId: 'area-paphos' },
  { id: 'loc3', name: 'Limassol Port', address: 'Limassol Old Port', fee: 40, areaId: 'area-limassol' },
  { id: 'loc4', name: 'Nicosia City', address: 'Nicosia City Centre', fee: 50, areaId: 'area-nicosia' },
];

export const initialExtras = [
  { id: 'ex1', name: 'Child Seat', icon: '🪑', price: 8, perDay: true, enabled: true, allowQty: true, maxQty: 3 },
  { id: 'ex2', name: 'GPS Navigation', icon: '🗺️', price: 5, perDay: true, enabled: true, allowQty: false, maxQty: 1 },
  { id: 'ex3', name: 'Roof Box', icon: '📦', price: 12, perDay: true, enabled: false, allowQty: false, maxQty: 1 },
  { id: 'ex4', name: 'Additional Driver', icon: '🧑‍🤝‍🧑', price: 10, perDay: true, enabled: true, allowQty: true, maxQty: 3 },
];

export const initialInsurance = [
  {
    id: 'ins1',
    name: 'Basic',
    icon: '🛡️',
    price: 0,
    perDay: true,
    desc: 'Statutory third-party only. Full excess applies.',
    excess: '€2,000',
    deposit: 500,
    color: 'var(--bd)',
  },
  {
    id: 'ins2',
    name: 'Standard',
    icon: '🛡️🛡️',
    price: 12,
    perDay: true,
    desc: 'Reduced excess with collision damage waiver.',
    excess: '€800',
    deposit: 300,
    color: 'var(--bl)',
    recommended: true,
  },
  {
    id: 'ins3',
    name: 'Full Cover',
    icon: '🛡️🛡️🛡️',
    price: 22,
    perDay: true,
    desc: 'Zero excess, all risks covered including theft.',
    excess: '€0',
    deposit: 0,
    color: 'var(--gr)',
  },
];

export const initialCompanySettings = {
  name: 'FleetRent Cyprus',
  slug: 'democyprus',
  phone: '+357 99 000 000',
  email: 'info@fleetrentcyprus.cy',
  website: 'www.fleetrentcyprus.cy',
  address: 'Paphos, Cyprus',
  vatNum: 'CY12345678X',
  currency: 'EUR',
  bankDetails: '',
  invPrefix: 'PF-',              // pro forma number prefix (system is pro forma only)
  invNext: 6,
  invFooter: 'Thank you for your business!',
  brandColor: '#1A3A5C',
  logoDataUrl: null,
  bookingConfirmation: 'manual',
  enableLeasing: true,           // show leasing UI (Add Lease button, Type column, MRR card)
  enableEquipment: false,        // show equipment/machinery UI (built in next phase)
  stripePublicKey: '',
  stripeSecretKey: '',
  stripeMode: 'test',
  payProvider: 'stripe',
  minAdvanceHours: 6,
  bufferHours: 12,
  maxAdvanceDays: 90,
  policies: {
    cancellation: '',
    deposit: '',
    late: '',
    damage: '',
    general: '',
  },
  reqPassportNum: 'optional',
  reqLicenceNum: 'optional',
  reqLicExpiry: 'hidden',
  reqPassportPhoto: 'hidden',
  reqLicencePhoto: 'hidden',
  reqSignAgreement: 'optional',

  // ── Self-service booking policies (Manage-My-Booking portal) ──
  // Cancellation refund tiers — system matches the highest tier the customer
  // still qualifies for at cancel time. Keep sorted descending by hoursBeforePickup.
  cancellationPolicy: [
    { hoursBeforePickup: 168, refundPercent: 100 },  // 7+ days  → 100%
    { hoursBeforePickup: 48,  refundPercent: 90  },  // 48h–7d  → 90%
    { hoursBeforePickup: 24,  refundPercent: 50  },  // 24–48h  → 50%
    { hoursBeforePickup: 0,   refundPercent: 0   },  // 0–24h   → 0%
  ],
  noShowDelayHours:        24,   // auto-cancel no-shows N hours after pickup time (0 = off)
  dateChangeCutoffHours:   24,   // hide "change dates" within N hours of pickup
  maxDateChanges:          1,    // max self-service date changes per booking
  // Refund processing fee policy (Stripe ~1.4-2.9% · Viva ~1.95% · PayPal ~2.9%)
  transactionFeePolicy: {
    onFullCancel:    false,   // absorb on full cancellations (operator-friendly default)
    onPartialRefund: true,    // deduct on partial refunds (date change shortening)
    onLateOrNoShow:  true,    // deduct on late cancel / no-show refunds
    feePercent:      3.0,
  },
};

// Default contract template — a starter document the operator can edit / replace.
// Body is HTML (rendered by the contenteditable editor). {{tokens}} are substituted
// at print/render time by renderContract(). Operators should replace this with the
// legal text their lawyer drafts.
const DEFAULT_RENTAL_BODY = `
<div style="text-align:center;margin-bottom:22px;">
  <div style="font-size:20px;font-weight:700;letter-spacing:.04em;text-transform:uppercase;">Vehicle Rental Agreement</div>
  <div style="font-size:11px;color:#666;margin-top:4px;">Republic of Cyprus</div>
</div>

<p>This Vehicle Rental Agreement (the &ldquo;Agreement&rdquo;) is entered into on <strong>{{today}}</strong>, between:</p>

<h2>The Lessor (Rental Company)</h2>
<table style="width:100%;font-size:12px;">
  <tr><td style="color:#666;width:32%;">Company</td><td><strong>{{lessor_name}}</strong></td></tr>
  <tr><td style="color:#666;">Registered Address</td><td>{{lessor_address}}</td></tr>
  <tr><td style="color:#666;">Company Registration No.</td><td>{{lessor_regnum}}</td></tr>
  <tr><td style="color:#666;">VAT No.</td><td>{{lessor_vat}}</td></tr>
  <tr><td style="color:#666;">Contact</td><td>{{lessor_phone}}</td></tr>
  <tr><td style="color:#666;">Email</td><td>{{lessor_email}}</td></tr>
</table>

<h2>The Lessee (Renter)</h2>
<table style="width:100%;font-size:12px;">
  <tr><td style="color:#666;width:32%;">Full Name</td><td><strong>{{lessee_name}}</strong></td></tr>
  <tr><td style="color:#666;">ID / Passport No.</td><td>{{lessee_passport}}</td></tr>
  <tr><td style="color:#666;">Date of Birth</td><td>{{lessee_dob}}</td></tr>
  <tr><td style="color:#666;">Address</td><td>{{lessee_address}}</td></tr>
  <tr><td style="color:#666;">Driving Licence No.</td><td>{{lessee_licence}}</td></tr>
  <tr><td style="color:#666;">Licence Expiry</td><td>{{lessee_licence_expiry}}</td></tr>
  <tr><td style="color:#666;">Phone</td><td>{{lessee_phone}}</td></tr>
  <tr><td style="color:#666;">Email</td><td>{{lessee_email}}</td></tr>
</table>

<p>The Lessor and the Lessee are referred to individually as a &ldquo;Party&rdquo; and collectively as the &ldquo;Parties&rdquo;.</p>

<h2>1. Vehicle Details</h2>
<table style="width:100%;font-size:12px;">
  <tr><td style="color:#666;width:32%;">Make &amp; Model</td><td><strong>{{vehicle_name}}</strong></td></tr>
  <tr><td style="color:#666;">Year</td><td>{{vehicle_year}}</td></tr>
  <tr><td style="color:#666;">Registration No.</td><td>{{vehicle_plate}}</td></tr>
  <tr><td style="color:#666;">VIN / Chassis No.</td><td>{{vehicle_vin}}</td></tr>
  <tr><td style="color:#666;">Colour</td><td>{{vehicle_colour}}</td></tr>
  <tr><td style="color:#666;">Fuel Type</td><td>{{vehicle_fuel}}</td></tr>
  <tr><td style="color:#666;">Transmission</td><td>{{vehicle_transmission}}</td></tr>
  <tr><td style="color:#666;">Odometer (out)</td><td>{{vehicle_mileage}} km</td></tr>
  <tr><td style="color:#666;">Fuel Level (out)</td><td>Empty &nbsp; &frac14; &nbsp; &frac12; &nbsp; &frac34; &nbsp; Full</td></tr>
  <tr><td style="color:#666;">Existing Damage</td><td>See attached condition report / diagram</td></tr>
</table>

<h2>2. Rental Period</h2>
<table style="width:100%;font-size:12px;">
  <tr><td style="color:#666;width:32%;">Pick-up Date &amp; Time</td><td>{{start_date}} at {{start_time}}</td></tr>
  <tr><td style="color:#666;">Pick-up Location</td><td>{{pickup_location}}</td></tr>
  <tr><td style="color:#666;">Return Date &amp; Time</td><td>{{end_date}} at {{end_time}}</td></tr>
  <tr><td style="color:#666;">Return Location</td><td>{{return_location}}</td></tr>
  <tr><td style="color:#666;">Total Rental Days</td><td>{{duration_days}} days</td></tr>
</table>

<h2>3. Rental Charges &amp; Payment</h2>
<table style="width:100%;font-size:12px;">
  <tr><td style="color:#666;width:60%;">Daily Rate (excl. VAT)</td><td style="text-align:right;">&euro; {{daily_rate}}</td></tr>
  <tr><td style="color:#666;">Number of Days</td><td style="text-align:right;">{{duration_days}}</td></tr>
  <tr><td style="color:#666;">Optional Extras</td><td style="text-align:right;">{{extras}}</td></tr>
  <tr><td style="border-top:1px solid #ddd;padding-top:6px;font-weight:700;">TOTAL DUE</td><td style="text-align:right;border-top:1px solid #ddd;padding-top:6px;font-weight:700;">&euro; {{total_contract}}</td></tr>
  <tr><td style="color:#666;">Security Deposit (refundable)</td><td style="text-align:right;">&euro; {{deposit}}</td></tr>
  <tr><td style="color:#666;">Payment Method</td><td style="text-align:right;">{{deposit_method}}</td></tr>
</table>

<h2>4. Additional Authorised Drivers</h2>
<p>Only the Lessee and the persons listed below are permitted to drive the Vehicle. Any unauthorised driver invalidates insurance coverage and is a material breach of this Agreement.</p>
<table style="width:100%;font-size:12px;">
  <tr><td style="color:#666;width:32%;">Driver 2 &mdash; Full Name</td><td>______________________________</td></tr>
  <tr><td style="color:#666;">ID / Licence No.</td><td>_______________ &nbsp; Expiry: __________</td></tr>
  <tr><td style="color:#666;">Driver 3 &mdash; Full Name</td><td>______________________________</td></tr>
  <tr><td style="color:#666;">ID / Licence No.</td><td>_______________ &nbsp; Expiry: __________</td></tr>
</table>

<h2>5. Insurance</h2>
<p>5.1&nbsp; The Vehicle is covered by third-party liability insurance as required by Cyprus law. Comprehensive coverage (CDW) and theft protection are included subject to the excess amount stated below.</p>
<p>5.2&nbsp; Insurance plan: <strong>{{insurance_name}}</strong>. Insurance excess (Lessee&rsquo;s liability per incident): <strong>&euro; {{insurance_excess}}</strong>.</p>
<p>5.3&nbsp; Insurance does <strong>NOT</strong> cover: damage to tyres, wheels, rims, undercarriage, windscreen and glass (unless a separate waiver is purchased); damage caused by driving under the influence of alcohol or drugs; damage caused by an unauthorised driver; damage resulting from off-road use, racing, or wilful misconduct; damage caused while the Vehicle is loaded beyond its permitted capacity.</p>
<p>5.4&nbsp; In the event of an accident, theft, or damage, the Lessee must immediately (a) notify the Lessor, (b) report the incident to the Cyprus Police and obtain a written police report, and (c) complete the accident statement form. Failure to do so voids insurance coverage.</p>

<h2>6. Renter&rsquo;s Obligations</h2>
<p>The Lessee agrees to:</p>
<ol style="list-style-type:lower-alpha;">
  <li>Hold a valid driving licence accepted under Cyprus law throughout the rental period.</li>
  <li>Drive the Vehicle in a careful and lawful manner and comply with all Cyprus road traffic laws.</li>
  <li>Return the Vehicle in the same condition as received, save for fair wear and tear.</li>
  <li>Keep the Vehicle locked and secure when unattended.</li>
  <li>Use only the fuel type specified for the Vehicle (mis-fuelling is at the Lessee&rsquo;s full cost).</li>
  <li>Check oil, water, and tyre pressure regularly on rentals exceeding 7 days.</li>
  <li>Pay all parking fines, traffic violations, tolls, and related administrative fees incurred during the rental period.</li>
</ol>

<h2>7. Prohibited Use</h2>
<p>The Vehicle shall <strong>NOT</strong> be used:</p>
<ol style="list-style-type:lower-alpha;">
  <li>By any person other than the Lessee or an authorised driver listed in this Agreement.</li>
  <li>Under the influence of alcohol, drugs, or any substance impairing driving ability.</li>
  <li>For any illegal purpose, including the transport of contraband.</li>
  <li>For racing, rallying, performance testing, or any motor sport.</li>
  <li>To push or tow another vehicle or trailer (unless expressly authorised in writing).</li>
  <li>Off paved/sealed roads or in any area unsuitable for the Vehicle.</li>
  <li>Outside the Republic of Cyprus (including crossing into the northern areas) without the Lessor&rsquo;s prior written consent.</li>
  <li>For sub-letting, hire-or-reward, ride-sharing, or any commercial passenger transport.</li>
  <li>Smoking and the transport of pets are prohibited unless agreed in writing; a cleaning fee of &euro; 150 applies.</li>
</ol>

<h2>8. Damage, Loss &amp; Liability</h2>
<p>8.1&nbsp; The Lessee is liable for all damage, loss, or theft of the Vehicle and its accessories during the rental period, up to the insurance excess stated in Clause 5.2, or in full where insurance coverage is voided under this Agreement.</p>
<p>8.2&nbsp; The Lessee shall pay the cost of repairing any damage, plus loss of use during the repair period at the daily rental rate, and any administrative fee not exceeding &euro; 50.</p>
<p>8.3&nbsp; Loss of keys, registration document, or licence plates: &euro; 100 per item.</p>
<p>8.4&nbsp; The security deposit may be applied by the Lessor towards any sums owed by the Lessee under this Agreement.</p>

<h2>9. Fuel &amp; Mileage</h2>
<p>9.1&nbsp; Fuel policy: the Vehicle is provided with the fuel level stated in Clause 1 and must be returned with the same level. Missing fuel will be charged at the local pump rate plus a refuelling service fee of &euro; 20.</p>
<p>9.2&nbsp; Mileage: unlimited unless otherwise agreed at booking. Excess kilometres (where a cap applies) are charged at the contracted per-km rate.</p>

<h2>10. Late Return &amp; Extensions</h2>
<p>10.1&nbsp; Any extension of the rental period must be agreed with the Lessor in advance and in writing.</p>
<p>10.2&nbsp; Late return without prior agreement is charged at the full daily rate plus a late fee of &euro; 30 per day. Returns more than 24 hours late without contact may be reported to the Police as unauthorised use.</p>

<h2>11. Termination</h2>
<p>The Lessor may terminate this Agreement and reclaim the Vehicle immediately, at the Lessee&rsquo;s cost, if the Lessee breaches any material term of this Agreement, including non-payment, prohibited use, or providing false information.</p>

<h2>12. Data Protection</h2>
<p>The Lessor processes the Lessee&rsquo;s personal data in accordance with the EU General Data Protection Regulation (GDPR) and Cyprus Law 125(I)/2018, solely for the purposes of this Agreement, insurance, and compliance with applicable law. The Lessee has rights of access, rectification, and erasure as set out in the Lessor&rsquo;s privacy policy.</p>

<h2>13. Governing Law &amp; Jurisdiction</h2>
<p>This Agreement is governed by the laws of the Republic of Cyprus. Any dispute arising out of or in connection with this Agreement shall be subject to the exclusive jurisdiction of the competent courts of Cyprus.</p>

<h2>14. Entire Agreement</h2>
<p>This Agreement, together with any annexes (vehicle condition report, additional driver list, optional waivers), constitutes the entire agreement between the Parties and supersedes any prior arrangements. No variation is binding unless in writing and signed by both Parties.</p>

<h2>Signatures</h2>
<p>By signing below, both Parties confirm that they have read, understood, and agreed to all terms of this Agreement, including the vehicle condition report attached hereto.</p>
<table style="width:100%;margin-top:24px;">
  <tr>
    <td style="width:48%;padding-right:14px;vertical-align:top;border-top:1px solid #888;padding-top:10px;">
      <div style="font-size:10px;color:#888;text-transform:uppercase;letter-spacing:.05em;margin-bottom:8px;">For the Lessor</div>
      <div style="font-size:11px;color:#666;">Name: {{lessor_name}}</div>
      <div style="font-size:11px;color:#666;margin-top:6px;">Position: ____________________</div>
      <div style="font-size:11px;color:#666;margin-top:14px;">Signature: ____________________</div>
      <div style="font-size:11px;color:#666;margin-top:6px;">Date: ____________________</div>
      <div style="font-size:11px;color:#666;margin-top:6px;">Company stamp:</div>
    </td>
    <td style="width:48%;padding-left:14px;vertical-align:top;border-top:1px solid #888;padding-top:10px;">
      <div style="font-size:10px;color:#888;text-transform:uppercase;letter-spacing:.05em;margin-bottom:8px;">The Lessee</div>
      <div style="font-size:11px;color:#666;">Name: {{lessee_name}}</div>
      <div style="font-size:11px;color:#666;margin-top:14px;">Signature:</div>
      <div style="margin-top:6px;">{{signature}}</div>
      <div style="font-size:11px;color:#666;margin-top:6px;">Date: {{signed_date}}</div>
    </td>
  </tr>
</table>

<h2 style="page-break-before:always;">Annex A &mdash; Vehicle Condition Report</h2>
<p style="font-size:11px;color:#444;">To be completed at pick-up and at return. Mark existing damage on the diagram below (S = Scratch, D = Dent, B = Broken, R = Rust).</p>
<table style="width:100%;font-size:12px;">
  <tr><td style="color:#666;width:40%;">Odometer at Pick-up</td><td>{{vehicle_mileage}} km</td></tr>
  <tr><td style="color:#666;">Odometer at Return</td><td>____________ km</td></tr>
  <tr><td style="color:#666;">Total km Driven</td><td>____________ km</td></tr>
  <tr><td style="color:#666;">Fuel at Pick-up</td><td>Empty &nbsp; &frac14; &nbsp; &frac12; &nbsp; &frac34; &nbsp; Full</td></tr>
  <tr><td style="color:#666;">Fuel at Return</td><td>Empty &nbsp; &frac14; &nbsp; &frac12; &nbsp; &frac34; &nbsp; Full</td></tr>
  <tr><td style="color:#666;">Exterior condition</td><td>Acceptable &nbsp;/&nbsp; Damage noted (describe below)</td></tr>
  <tr><td style="color:#666;">Interior condition</td><td>Acceptable &nbsp;/&nbsp; Damage noted (describe below)</td></tr>
  <tr><td style="color:#666;">Spare tyre &amp; tools</td><td>Present &nbsp;/&nbsp; Missing</td></tr>
  <tr><td style="color:#666;">Documents (V5, insurance)</td><td>Present &nbsp;/&nbsp; Missing</td></tr>
</table>
<p style="font-size:11px;color:#444;margin-top:14px;">Notes / damage description:</p>
<p style="font-size:11px;color:#444;border-bottom:1px solid #ccc;height:14px;">&nbsp;</p>
<p style="font-size:11px;color:#444;border-bottom:1px solid #ccc;height:14px;">&nbsp;</p>
<p style="font-size:11px;color:#444;border-bottom:1px solid #ccc;height:14px;">&nbsp;</p>
<table style="width:100%;margin-top:20px;font-size:11px;">
  <tr>
    <td style="width:50%;padding-right:14px;">Lessor signature: ____________________</td>
    <td style="width:50%;padding-left:14px;">Lessee signature: ____________________</td>
  </tr>
</table>

<p style="font-size:10px;color:#888;margin-top:24px;font-style:italic;">&mdash; Starter template. Have it reviewed by a Cyprus-licensed lawyer before use.</p>
`.trim();

const DEFAULT_LEASE_BODY = `
<div style="text-align:center;margin-bottom:18px;">
  <div style="font-size:18px;font-weight:700;">{{lessor_name}}</div>
  <div style="font-size:11px;color:#666;">{{lessor_address}} · {{lessor_phone}} · {{lessor_email}}</div>
  <div style="font-size:11px;color:#666;">VAT: {{lessor_vat}}</div>
  <div style="font-size:16px;font-weight:700;letter-spacing:.05em;margin-top:14px;text-transform:uppercase;">Long-term Vehicle Lease Agreement</div>
  <div style="font-size:11px;color:#888;margin-top:2px;">Contract {{contract_id}} · {{today}}</div>
</div>

<h2>1. Parties</h2>
<p>This Lease Agreement is made between <strong>{{lessor_name}}</strong> ("the Lessor"), having its registered office at {{lessor_address}}, VAT {{lessor_vat}}; and <strong>{{lessee_name}}</strong> {{lessee_company}} ("the Lessee"), VAT {{lessee_vat}}, of {{lessee_address}}.</p>

<h2>2. Subject of Agreement</h2>
<p>The Lessor agrees to lease, and the Lessee agrees to take on lease, the vehicle described in Schedule A below for the term and on the conditions set out herein.</p>

<h2>3. Schedule A — Vehicle Particulars</h2>
<table style="width:100%;font-size:12px;">
  <tr><td style="color:#666;width:35%;">Make / Model</td><td><strong>{{vehicle_name}}</strong></td></tr>
  <tr><td style="color:#666;">Plate</td><td>{{vehicle_plate}}</td></tr>
  <tr><td style="color:#666;">Year</td><td>{{vehicle_year}}</td></tr>
  <tr><td style="color:#666;">VIN / Chassis</td><td>{{vehicle_vin}}</td></tr>
  <tr><td style="color:#666;">Colour</td><td>{{vehicle_colour}}</td></tr>
  <tr><td style="color:#666;">Mileage at delivery</td><td>{{vehicle_mileage}} km</td></tr>
  <tr><td style="color:#666;">Fuel type</td><td>{{vehicle_fuel}}</td></tr>
</table>

<h2>4. Term</h2>
<table style="width:100%;font-size:12px;">
  <tr><td style="color:#666;width:35%;">Start date</td><td>{{start_date}}</td></tr>
  <tr><td style="color:#666;">End date</td><td>{{end_date}}</td></tr>
  <tr><td style="color:#666;">Term</td><td>{{term_months}} months</td></tr>
  <tr><td style="color:#666;">Delivery location</td><td>{{pickup_location}}</td></tr>
  <tr><td style="color:#666;">Return location</td><td>{{return_location}}</td></tr>
</table>

<h2>5. Financial Terms</h2>
<table style="width:100%;font-size:12px;">
  <tr><td style="color:#666;width:35%;">Monthly lease payment</td><td><strong>€{{monthly_rate}}</strong></td></tr>
  <tr><td style="color:#666;">Total contract value</td><td>€{{total_contract}}</td></tr>
  <tr><td style="color:#666;">Security deposit</td><td>€{{deposit}} ({{deposit_method}})</td></tr>
  <tr><td style="color:#666;">Annual mileage cap</td><td>{{annual_mileage_cap}} km/year</td></tr>
  <tr><td style="color:#666;">Included services</td><td>{{included_services}}</td></tr>
</table>

<h2>6. Lessee Obligations</h2>
<ol>
  <li>Monthly lease payments are due on or before the invoice due date stated in each monthly invoice.</li>
  <li>The Lessee must keep the vehicle insured, taxed and roadworthy throughout the lease term.</li>
  <li>Scheduled maintenance must be carried out at the Lessor-approved service centre.</li>
  <li>Excess mileage above the agreed annual cap will be charged at the contracted per-kilometre rate.</li>
  <li>Modifications to the vehicle are not permitted without prior written consent from the Lessor.</li>
  <li>The vehicle may not be sub-leased or used outside the agreed territory.</li>
  <li>Loss, theft, or total damage of the vehicle remains the responsibility of the Lessee, subject to insurance terms.</li>
</ol>

<h2>7. Early Termination</h2>
<p>Early termination may incur a penalty equivalent to up to two monthly payments unless otherwise agreed in writing.</p>

<h2>8. Return Condition</h2>
<p>The vehicle must be returned at lease end in fair condition (allowing normal wear), with all keys, documents and accessories.</p>

<h2>9. Governing Law</h2>
<p>This Agreement is governed by the laws of the Republic of Cyprus and the courts of Paphos shall have exclusive jurisdiction over any disputes.</p>

<h2>10. Signatures</h2>
<table style="width:100%;margin-top:24px;">
  <tr>
    <td style="width:50%;padding-right:14px;border-top:1px solid #888;">
      <div style="font-size:10px;color:#888;">For the Lessor — {{lessor_name}}</div>
    </td>
    <td style="width:50%;padding-left:14px;border-top:1px solid #888;">
      <div style="font-size:10px;color:#888;">For the Lessee — {{lessee_name}} · {{signed_date}}</div>
      <div style="margin-top:6px;">{{signature}}</div>
    </td>
  </tr>
</table>
`.trim();

export const initialAgreementTemplates = [
  {
    id: 'agr-standard',
    name: 'Standard Vehicle Agreement',
    icon: '📄',
    desc: 'Short-term rental contract — edit and replace with your company\'s legal text',
    appliesTo: 'rental',
    body: DEFAULT_RENTAL_BODY,
    clauses: [],   // legacy field, no longer used
    isDefault: true,
  },
  {
    id: 'agr-lease',
    name: 'Long-term Lease Agreement',
    icon: '📅',
    desc: 'Multi-month lease contract — edit and replace with your company\'s legal text',
    appliesTo: 'lease',
    body: DEFAULT_LEASE_BODY,
    clauses: [],
    isDefault: false,
  },
];

export const initialPOIs = [
  { id: 'poi1', name: 'Main Office', type: 'office', icon: '🏢', color: '#1C5FAD', addr: '12 Apostolou Pavlou, Paphos', x: 250, y: 265, alert: 'none', radius: 200 },
  { id: 'poi2', name: 'Paphos Airport', type: 'airport', icon: '✈️', color: '#1C5FAD', addr: 'Paphos International Airport', x: 720, y: 300, alert: 'enter', radius: 500 },
  { id: 'poi3', name: 'BP Fuel Station', type: 'fuel', icon: '⛽', color: '#B8720A', addr: 'Leoforos Pafou', x: 400, y: 240, alert: 'none', radius: 100 },
  { id: 'poi4', name: 'Pafos AutoService', type: 'garage', icon: '🔧', color: '#5B3E9E', addr: 'Industrial Zone, Paphos', x: 160, y: 200, alert: 'none', radius: 150 },
];
